import { create } from 'zustand'

interface AnnouncerState {
	message: string
}

export const useAnnouncerStore = create<AnnouncerState>(() => ({ message: '' }))

/**
 * Tells a screen reader where a shortcut landed ("Device Management", "Create"). A live region only
 * speaks on a text change, so announcing the same destination twice in a row clears it first.
 */
export function announce(message: string): void {
	useAnnouncerStore.setState({ message: '' })
	requestAnimationFrame(() => {
		useAnnouncerStore.setState({ message })
	})
}

/** A nav command's title is "Go to X" for the palette row; the announcement speaks just "X". */
export function stripGoToPrefix(title: string): string {
	return title.replace(/^Go to /, '')
}
